import BottomNavigation from "components/BottomNavigation"
import ColorPicker from "components/ColorPicker"
import {
  CustomImageField,
  SingleSelectField,
  TextField,
} from "components/RenderInput"
import { FONTS } from "constants/fonts"
import { FORM_NAMES } from "constants/index"
import React from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field, change, formValueSelector } from "redux-form"
import { updateWebsiteConfigs } from "store/actions"
import { getFileBlob } from "utils"
import { required } from "./utils"

const WebsiteBranding = ({
  formValues,
  websiteConfigs,
  change,
  handleBack,
  userId,
  updateWebsiteConfigs,
  handleSubmit,
}) => {
  const saveWebsiteBranding = () => {
    let logo = null
    let banner = null
    let logo_url = formValues?.logo_url?.editedImage
    let banner_url = formValues?.banner_url?.editedImage

    if (formValues?.delete_logo && !!formValues?.logo_url?.editedImage) {
      logo = {
        vendor_id: websiteConfigs?.vendor_id,
        dir: "background",
        user_id: userId,
        files: [getFileBlob(formValues?.logo_url?.editedImage)],
      }
      logo_url = null
    }
    if (formValues?.delete_banner && !!formValues?.banner_url?.editedImage) {
      banner = {
        vendor_id: websiteConfigs?.vendor_id,
        dir: "background",
        user_id: userId,
        files: [getFileBlob(formValues?.banner_url?.editedImage)],
      }
      banner_url = null
    }

    updateWebsiteConfigs({ ...formValues, logo_url, banner_url, logo, banner })
  }

  return (
    <React.Fragment>
      <Row>
        <Col xl={8}>
          <Card>
            <CardHeader className="mt-3">
              <h4>SET LOGO</h4>
            </CardHeader>
            <CardBody className="shadow-sm py-1">
              <Row>
                <Col
                  xs={"auto"}
                  className="mt-2"
                  style={{ minWidth: "fit-content" }}
                >
                  <label>Logo:</label>
                </Col>
                <Col xs="auto" className="my-1">
                  <Field
                    name="logo_url"
                    type="file"
                    component={CustomImageField}
                    onChange={() => {
                      change("websiteBranding.delete_logo", 1)
                    }}
                  />
                </Col>
                <Col
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                  }}
                >
                  {formValues?.logo_url &&
                    formValues?.logo_url?.editedImage && (
                      <img
                        src={
                          formValues?.logo_url?.editedImage
                            ? formValues?.logo_url?.editedImage
                            : ""
                        }
                        alt="logo"
                        // className="rounded avatar-xl"
                        style={{ blockSize: "auto", maxWidth: "200px" }}
                      />
                    )}
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Card>
            <CardHeader className="mt-2">
              <h4>SET BANNER</h4>
            </CardHeader>
            <CardBody className="shadow-sm py-1">
              <Row>
                <Col
                  xs={"auto"}
                  className="mt-2"
                  style={{ minWidth: "fit-content" }}
                >
                  <label>Banner:</label>
                </Col>
                <Col xs="auto" className="my-1">
                  <Field
                    name="banner_url"
                    type="file"
                    component={CustomImageField}
                    onChange={() => {
                      change("websiteBranding.delete_banner", 1)
                    }}
                  />
                </Col>
                <Col className="d-flex flex-row justify-content-end">
                  {formValues?.banner_url &&
                    formValues?.banner_url?.editedImage && (
                      <img
                        src={
                          formValues?.banner_url?.editedImage
                            ? formValues?.banner_url?.editedImage
                            : ""
                        }
                        alt="banner"
                        // className="rounded avatar-xl"
                        style={{ blockSize: "auto", maxWidth: "200px" }}
                      />
                    )}
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Card>
            <CardHeader className="mt-2">
              <h4>SET COLOR/FONT</h4>
            </CardHeader>
            <CardBody className="shadow-sm py-1">
              <Row className="my-3">
                <Col style={{ minWidth: "fit-content" }}>
                  <label>Primary Color:</label>
                </Col>
                <Col xs="auto">
                  <Field
                    name="primary_color"
                    type="color"
                    component={ColorPicker}
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col style={{ minWidth: "fit-content" }}>
                  <label>Secondary Color:</label>
                </Col>
                <Col xs="auto">
                  <Field
                    name="secondary_color"
                    type="color"
                    component={ColorPicker}
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col style={{ minWidth: "fit-content" }}>
                  <label>Background Color:</label>
                </Col>
                <Col xs="auto">
                  <Field name="bg_color" type="color" component={ColorPicker} />
                </Col>
              </Row>
              <Row className="my-3">
                <Col style={{ minWidth: "fit-content" }}>
                  <label>Font Family:</label>
                </Col>
                <Col xs="auto">
                  <div style={{ width: "270px" }}>
                    <Field
                      className="full-width"
                      name="font_family"
                      component={SingleSelectField}
                      options={FONTS.map(font => ({
                        value: font.value,
                        label: font.text,
                      }))}
                      placeholder="Select Font Family"
                    />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Card>
            <CardHeader className="mt-2">
              <h4>SET SECTION TITLES</h4>
            </CardHeader>
            <CardBody className="shadow-sm py-1">
              <Row>
                <Col className="mt-2" style={{ minWidth: "fit-content" }}>
                  <label>Member Directory Title:</label>
                </Col>
                <Col xs="auto" xl={3} className="my-1">
                  <Field
                    name="member_directory_title"
                    component={TextField}
                    validate={[required]}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="mt-2" style={{ minWidth: "fit-content" }}>
                  <label>Member Center Title:</label>
                </Col>
                <Col xs="auto" xl={3} className="my-1">
                  <Field
                    name="member_center_title"
                    component={TextField}
                    validate={[required]}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="mt-2" style={{ minWidth: "fit-content" }}>
                  <label>Discussion Board Title:</label>
                </Col>
                <Col xs="auto" xl={3} className="my-1">
                  <Field
                    name="discussion_board_title"
                    component={TextField}
                    validate={[required]}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <BottomNavigation
        handleBack={handleBack}
        handleSave={handleSubmit(saveWebsiteBranding)}
      />
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.PLATFORM_SETTINGS)

const mapStateToProps = state => ({
  formValues: selector(state, "websiteBranding"),
  websiteConfigs: state.PlatformSettings.websiteConfigs,
  userId: state.Login.authUser.id,
})

const mapDispatchToProps = dispatch => ({
  change: (field, value) =>
    dispatch(change(FORM_NAMES.PLATFORM_SETTINGS, `${field}`, value)),
  updateWebsiteConfigs: values => dispatch(updateWebsiteConfigs(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(WebsiteBranding)
